module.exports = __webpack_public_path__ + "static/media/no-activity.52be18cc.png";